import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Title = ({ titleTag: TitleTag, className, breakPoint, children }) => {
  return (
    <TitleTag
      className={classNames(
        {
          'mb-0': !breakPoint,
          [`mb-${breakPoint}-0`]: !!breakPoint,
        },
        className,
      )}
    >
      {children}
    </TitleTag>
  );
};

Title.propsType = {
  breakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  children: PropTypes.node,
};

Title.defaultProps = { titleTag: 'h5' };

const CardHeader = ({ title, light, titleTag, titleClass, className, breakPoint, children, titleExtension: TitleExtension, beforeTitle: BeforeTitle }) => {
  const inner = (
    <>
      {BeforeTitle && <>{typeof BeforeTitle === 'function' ? <BeforeTitle /> : BeforeTitle}</>}
      {title}
      {TitleExtension && <>{typeof TitleExtension === 'function' ? <TitleExtension /> : TitleExtension}</>}
    </>
  );
  return (
    <div className={classNames('card-header', { 'bg-light': light }, className)}>
      {children ? (
        <div className="d-flex align-center justify-between flex-wrap gap-8">
          <Title breakPoint={breakPoint} titleTag={titleTag} className={titleClass}>
            <div className="d-flex align-center gap-10">
              {inner}
            </div>
          </Title>
          <div className="d-flex align-center gap-8">
            {children}
          </div>
        </div>
      ) : (
        <Title breakPoint={breakPoint} titleTag={titleTag} className={titleClass}>
          <div className="d-flex align-center gap-10">
            {inner}
          </div>
        </Title>
      )}
    </div>
  );
};

CardHeader.propTypes = {
  title: PropTypes.node,
  titleExtension: PropTypes.any,
  beforeTitle: PropTypes.any,
  light: PropTypes.bool,
  breakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  titleClass: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

CardHeader.defaultProps = {
  light: true,
  titleExtension: null,
  beforeTitle: null,
};

export default CardHeader;
